export const accountRoutes = [
  'AccountView',
  'ProfileView',
  'AddressesView',
  'OrderHistoryView',
  'ExternalLinksView',
  'ManageCardsView',
  'GiftCardsView',
  'RewardsView',
  'FavoriteItemsView',
]

// Routes that must never be recorded as the account "back to" origin.
export const routesToSkip = [
  'PasswordResetView',
  'OrderQuoteView',
  'CheckInView',
  'NotFoundView',
  'LoginView',
  'SignUpView',
]

// The account "back to" origin is captured centrally by the global router guard
// in src/router/index.js (it fires reliably on every navigation, unlike the
// per-component beforeRouteLeave guards this mixin previously used). This empty
// default export is kept only so existing `...trackMainRoutes` spreads in the
// views remain valid no-ops.
export default {}
